export default {
    backend: {
        url: "https://rezerv-api-ing.bouygues-immobilier.com"
    },
};